import React, { useEffect } from "react";
import withRouter from "components/Common/withRouter";
import { del } from "../../helpers/api_helper";
//redux
import { useNavigate, useParams } from "react-router-dom";
import { REMOVE_COLLHUB } from "helpers/api_endpoints";

const RemoveCollHub = () => {
    const history = useNavigate();
    const params = useParams();
    const id = params.id;
    const navigate = useNavigate();

    useEffect(() => {
        del(REMOVE_COLLHUB, { id })
            .then(response => {
                navigate('/collhub', { state: { successMsg: 'deleted SuccessFully' } });
            })
            .catch(error => {
                console.log(error);
            })
    });

    return <React.Fragment>Removed</React.Fragment>;
};

export default withRouter(RemoveCollHub);